import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExternalBookingInfo } from '../../../model/external-booking-info';
import { ExternalBookingChannel } from '../../../model/external-booking-channel';
import { GymUtils } from '../../../util/gym-util';

@Component({
  selector: 'gymfinder-external-booking-info',
  templateUrl: './external-booking-info.component.html',
  styleUrls: ['./external-booking-info.component.scss'],
  standalone: false,
})
export class ExternalBookingInfoComponent {
  @Input()
  externalBookingInfo: ExternalBookingInfo | undefined;

  @Input()
  classBookingEnabled: boolean;

  @Input()
  editMode: boolean;

  @Output()
  externalBookingInfoChanged = new EventEmitter<ExternalBookingInfo>();

  public get hasExternalBookingChannels(): boolean {
    return (
      this.externalBookingInfo?.requirementType != null &&
      this.externalBookingInfo.requirementType !== 'NONE'
    );
  }
  public get scheduleLink(): string | undefined {
    return this.externalBookingInfo?.link ?? '';
  }

  public set scheduleLink(value: string) {
    this.setExternalBookingFieldValue('link', value);
    this.externalBookingInfoChanged.emit(this.externalBookingInfo);
  }

  public get channelEmail() {
    return this.externalBookingInfo?.channel?.email ?? '';
  }

  public set channelEmail(value: string) {
    this.changeChannelFieldValue('email', value);
  }

  public get channelPhone() {
    return this.externalBookingInfo?.channel?.phone ?? '';
  }

  public set channelPhone(value: string) {
    this.changeChannelFieldValue('phone', value);
  }

  public get channelLink() {
    return this.externalBookingInfo?.channel?.link ?? '';
  }

  public set channelLink(value: string) {
    this.changeChannelFieldValue('link', value);
  }

  private changeChannelFieldValue(
    field: keyof ExternalBookingChannel,
    value: string
  ) {
    this.externalBookingInfo!.channel =
      this.externalBookingInfo!.channel ?? ({} as ExternalBookingChannel);
    this.externalBookingInfo!.channel[field] = value;
    this.externalBookingInfoChanged.emit(this.externalBookingInfo);
  }

  public get requirementType(): string | undefined {
    return this.externalBookingInfo?.requirementType ?? '';
  }

  public set requirementType(value: string) {
    this.setExternalBookingFieldValue('requirementType', value);
    if (value === 'NONE') {
      this.externalBookingInfo!.channel = {} as ExternalBookingChannel;
    }
    this.externalBookingInfoChanged.emit(this.externalBookingInfo);
  }

  setExternalBookingFieldValue(
    field: Exclude<keyof ExternalBookingInfo, 'channel'>,
    value: string
  ) {
    this.externalBookingInfo =
      this.externalBookingInfo ?? ({} as ExternalBookingInfo);
    this.externalBookingInfo[field] = value;
  }

  requirementTrackByFn(index: number, item: { label: string; value: string }) {
    return item.value;
  }

  public get requirementTypes(): { value: string; label: string }[] {
    return GymUtils.requirementTypes;
  }

  clearExternalBookingInfo() {
    delete this.externalBookingInfo!.channel;
    delete this.externalBookingInfo!.requirementType;
    this.externalBookingInfoChanged.emit(this.externalBookingInfo);
  }

  public get isClearExternalBookingVisible(): boolean {
    if (this.classBookingEnabled) {
      return false;
    }

    const requirementRadioButtonValue =
      this.externalBookingInfo?.requirementType;
    const bookingInfoHasAtLeastOneInputValue =
      this.externalBookingInfo?.channel?.email ??
      this.externalBookingInfo?.channel?.phone ??
      this.externalBookingInfo?.channel?.link;

    return Boolean(
      requirementRadioButtonValue ?? bookingInfoHasAtLeastOneInputValue
    );
  }
}
